<template>

  <div class="homeContent">
    <div class="leftNav">
      <!-- 左边时间 -->
      <div class="leftTitle">
        <div class="titleItem" v-for="(v,i) in titleList" :key="i" :class="currentTitle == i ? 'titleItemCurrent' : '' "
          @click="todayOrhistory(i)"> {{v}} </div>
        <div>
          <el-input v-model="queryName" @change="searchMain" placeholder="输入金额、餐单号、桌号进行查询" suffix-icon="el-icon-search">
          </el-input>
        </div>
        <!-- <div class="search" @click="searchMain(queryName)"><i class="el-icon-search"></i> 搜索 </div> -->
        <div class="searchBtn" @click="queryDialog = true"> 组合查询</div>
        <div class="search" @click="todoExport"> 导出/打印 </div>
        <!-- <div class="search"> 打印 </div> -->
      </div>
      <!-- 左边内容 -->
      <div class="leftMain" id="tablePrintExport">
        <div class="selectTitle" v-if="leftMenuList.length">
          <div>
            单号
          </div>
          <div>
            营业点
          </div>
          <div>
            桌号
          </div>
          <div>
            桌号描述
          </div>
          <div>
            营业日期
          </div>
          <div>
            班次
          </div>
          <div>
            工号
          </div>
          <div>
            人数
          </div>
          <div>
            金额
          </div>
          <div>
            付款方式
          </div>
          <div>
            状态
          </div>
        </div>
        <div class="contentItem" v-for="(v,i) in leftMenuList" :key="i" @click="queryDetails(v,i)"
          :class="mainCurrent == i ? 'currentContentItem' : '' ">
          <div>{{v.orderNum}}</div>
          <div>{{v.restaurant}} </div>
          <div>{{v.mealTableNum}}</div>


          <div>{{v.mealTableName}}</div>
          <div>{{v.businessDate}}</div>
          <div>
            {{v.shiftCode == 1 ? '早班'  : v.shiftCode == 2 ? '中班'  : v.shiftCode == 3 ? '晚班'  : v.shiftCode == 4 ? '夜班'  : '未知'}}
          </div>
          <div>{{v.userName}}</div>


          <div>{{v.peopleCount}}</div>




          <div style="text-align:right">￥{{v.allPrice.toFixed(2)}}</div>
          <div>{{v.checkType}}</div>

          <div>
            <img v-if="v.status == 'I'" src="../../assets/imgs/I.png" width="28px" height="38px" alt="">
            <img v-if="v.status == 'O'" src="../../assets/imgs/O.png" width="28px" height="38px" alt="">
            <img v-if="v.status == 'S'" src="../../assets/imgs/S.png" width="28px" height="38px" alt="">
            <img v-if="v.status == 'C'" src="../../assets/imgs/C.png" width="28px" height="38px" alt="">
            <img v-if="v.status == 'L'" src="../../assets/imgs/L.png" width="28px" height="38px" alt="">
            <img v-if="v.status == 'G'" src="../../assets/imgs/G.png" width="28px" height="38px" alt="">
            <img v-if="v.status == 'R'" src="../../assets/imgs/R.png" width="28px" height="38px" alt="">
          </div>
        </div>

      </div>
      <!-- 左边底部按钮 -->
      <div class="leftBottom">
        <div class="bottomOne">
          <span>餐单数：{{leftMenuList.length || 0}}</span>
          <span>总金额：{{allPrice ? allPrice.toFixed(2) : 0}}</span>
        </div>
        <div class="bottomTwo">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">所有
          </el-checkbox>
          <el-checkbox-group v-model="statusList" @change="checkListChange">

            <el-checkbox :label="v.label" v-for="(v,i) in checkList" :key="i">{{v.val}}</el-checkbox>
            <!-- <el-checkbox label="未结"></el-checkbox> -->
            <!-- <el-checkbox label="挂单"></el-checkbox> -->
            <!-- <el-checkbox label="取消"></el-checkbox> -->
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <div class="view">
      <order v-if="statusCode == 1" :dcStatus="dcStatus"  :showReCalc="showReCalc" @Success="Success"></order>

      <settleDetails v-else :billList="billList" :billOrder="billOrder"></settleDetails>
    </div>
    <el-dialog title="组合查询" :visible.sync="queryDialog" width="970px" center>
      <div>
        <div class="changeReason" v-if="currentTitle == 1">
          <div class="returnTitle">选择营业时间</div>
          <div class="block">
            <el-date-picker v-model="value1" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="changedate">
            </el-date-picker>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">选择营业点</div>
          <div class="returnItem">
            <div v-for="(v, i) in cantList" :key="i" :class="v.check  ? 'returnItemCurrent' : ''"
              @click="checkyydCurrent(v,i)">
              {{ v.description }}
            </div>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">选择班次</div>
          <div class="returnItem">
            <div v-for="(v, i) in ShiftList" :key="i" :class="v.check ? 'returnItemCurrent' : ''"
              @click="checkbcCurrent(v,i)">
              {{ v.name }}
            </div>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">结账工号</div>
          <div class="returnItem">
            <el-select v-model="workOption" clearable placeholder="请选择结账工号">
              <el-option v-for="item in workOptions" :key="item.userId" :label="item.username" :value="item.username">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">桌号</div>
          <div class="returnItem">
            <el-select v-model="ramadhinOption" clearable placeholder="请选择桌号">
              <el-option v-for="item in ramadhinOptions" :key="item.value" :label="item.mealTableCode"
                :value="item.mealTableCode">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">支付方式</div>
          <div class="returnItem">
            <el-select v-model="payOption" clearable placeholder="请选择支付方式">
              <el-option v-for="item in payOptions" :key="item.code_" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">餐单金额</div>
          <div class="returnItem">
            <el-input v-model="orderAmount" placeholder="请输入餐单金额"></el-input>
          </div>
        </div>
        <div class="changeReason">
          <div class="returnTitle">餐单号</div>
          <div class="returnItem">
            <el-input v-model="orderNumber" placeholder="请输入餐单号"></el-input>
          </div>
        </div>


      </div>
      <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: space-between;
        " class="dialog-footer">
        <div style="margin-left:30px">
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
              
            " @click="resetClick">重 置</el-button>
        </div>
        <div>
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="queryDialog = false">取 消</el-button>
          <el-button style="" type="primary" @click="CombinedQuery">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <div v-show="printFlag">
      <el-dialog title="打印" :visible.sync="printFlag" width="1000px" center>
        <div class="printSelect">
          <div class="printNameTxt">选择打印机：</div>

          <el-select v-model="printName" placeholder="请选择" class="PDateName" @change="changePDate">
            <el-option v-for="item in PDate" :key="item.code" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <printLine :tabelList="leftMenuList" :allNum="leftMenuList.length" :allPrice='allPrice'></printLine>
        <span slot="footer" class="dialog-footer">
          <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="printFlag = false">返 回</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="printexcel" v-preventReClick>导 出
          </el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="printtable" v-preventReClick>打 印
          </el-button>

        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import order from "../dashboard/components/rightOrder.vue";
  import settleDetails from './components/settlementDetails.vue'
  import DateUtils from "@/utils/DateUtils";
  import getLodop from '../../utils/Lodopfuncs';
  import PrintLine from '../components/printLine.vue';

  export default {
    components: {
      order,
      settleDetails,
      PrintLine
    },
    data() {
      return {
        statusCode: 1,
        leftMenuList: [],
        //当前选中行
        mainCurrent: -1,
        dcStatus: '',
        // checkList: ['O', 'G', 'S', 'C'],
        checkList: [{
            val: '已结(0)',
            label: 'O'
          },
          {
            val: '未结(G)',
            label: 'G'
          },
          {
            val: '挂单(S)',
            label: 'S'
          },
          {
            val: '取消(C)',
            label: 'C'
          },
        ],
        showReCalc: false,
        checkAll: false,
        isIndeterminate: true,
        queryDialog: false,
        currentTitle: 0,
        bcCurrent: [],
        yydCurrent: -1,
        titleList: ['本日', '历史'],
        queryList: ['早餐', '西餐厅', '清餐厅', '中餐厅', '所有'],
        value1: '',
        ShiftList: [{
            name: '所有',
            check: false,
            val: ''
          }, {
            name: '早班',
            check: false,
            val: 1
          },
          {
            name: '中班',
            check: false,
            val: 2
          },
          {
            name: '晚班',
            check: false,
            val: 3
          },
          {
            name: '夜班',
            check: false,
            val: 4
          },

        ],
        startTime: '',
        endTime: '',
        outletsIds: [],
        shiftCodes: [],
        status: ['O', 'G', 'S'],
        statusList: ['O', 'G', 'S'],
        timevalue1: '',
        allNum: 0,
        allPrice: 0,
        yyd: '',
        cantList: [],
        flag: true,
        shiftArr: [],
        ctArr: [],
        ctArrs: [],
        billList: [],
        billOrder: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate(time) {
            return time.getTime() > Date.now();
            // Date.now() - 24 * 60 * 60 * 1000
          },
        },
        none: false,
        //餐桌id
        tableId: "",
        queryName: "",
        //结账工号数组
        workOptions: [],
        //桌号数组
        ramadhinOptions: [],
        //支付方式数组
        payOptions: [],
        //结账工号选中数组
        workOption: '',
        //桌号选中数组
        ramadhinOption: '',
        //支付方式选中数组
        payOption: '',
        // 餐单金额
        orderAmount: "",
        // 餐单号
        orderNumber: "",
        printFlag: false,
        printName: '',
        PDate: '',
        buttonLoading: false,
        getlist: []
      };
    },
    watch: {


    },
    created() {
      // this.$store.commit('todayTime')
      this.cardNumber()
    },
    mounted() {
      let that = this
      this.$bus.on('statuss', value => {
        console.log('菜品详情 餐单详情按钮切换', value);
        this.statusCode = value;
        that.queryDetails(that.leftMenuList[this.mainCurrent], this.mainCurrent)
      })
      this.$bus.$on('cxRefund', v => {
        console.log(v);
        this.Success()
        this.onclicks(v)

      })

    },
    destroyed() {
      localStorage.removeItem('MenuQuery')
    },
    methods: {
      cardNumber() {
        let val = localStorage.getItem('MenuQuery')
        if (val) {
          this.tableId = JSON.parse(val).id
          this.currentTitle = 1,
            this.queryDialog = false
          this.status = ['S']
          this.startTime = ''
          this.endTime = ''
          this.fetchLeftMenu()
          this.getOutletsIdList()
        } else {
          this.getNowFormatDate()
          this.getOutletsIdList()
          this.fetchLeftMenu()
        }
      },
      //loading
      loading(text) {
        const loading = this.$loading({
          lock: true,
          text: text,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      },
      queryDetails(v, i) {
        console.log(v,'v-------')
        this.mainCurrent = i
        this.dcStatus = v.status

        var url = this.api.menuQueryInfoTo2 + '?orderRecordId=' + v.id + '&status=' + 'I'
        var methods = 'get'
        this.$axios({
          url,
          methods
        }).then(res => {
          console.log(res,'res---------------')
          localStorage.setItem('openTaiUser', JSON.stringify(res.data.data))
          this.$bus.emit('orderMenu', res.data.data)
          this.$bus.emit('routeStatus', 1)
          // this.$bus.emit('nowID', v.id)
          
          this.$bus.emit('nowID', v.mealTableId)

          this.$bus.emit('nowstatus', v.status)
          this.billOrder = res.data.data.orderMenusMap
          this.totalPrice = res.data.data.totalPrice
          const aimPrice = this.billOrder.reduce((p, n) => p + n.totalPrice, 0)
          console.log('MenuQuery.vue第469行:::aimPrice', aimPrice);
          this.showReCalc = aimPrice != this.totalPrice
          console.log('MenuQuery.vue第472行:::this.showReCalc', this.showReCalc);
        })
        var url = this.api.billList + '?orderRecordId=' + v.id
        var methods = 'get'
        this.$axios({
          url,
          methods
        }).then(res => {
          // this.billList = res.data.data;
          let newArr = []
          res.data.data.map((item, index) => {
            newArr.push(
              Object.assign(item, {
                updataMoney: ''
              })
            )
          })
          this.billList = newArr
          localStorage.setItem('queryDetails', JSON.stringify(v))
          this.$bus.$emit('orderRecordId', v.id)
        })
      },
      // 当天时间
      getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        this.timevalue1 = year + seperator1 + month + seperator1 + strDate;
        console.log('当天时间', this.timevalue1);
        this.startTime = this.timevalue1
        this.endTime = this.timevalue1
      },
      menuQueryTotal() {
        console.log('菜单查询')

        console.log(this.timevalue1);

        let url =
          `${this.api.menuQueryTotal}?startTime=${this.startTime}&endTime=${this.endTime}${this.outletsIds.length !== 0 ? '&outletsIds=' : ''}${this.outletsIds}${this.shiftCodes.length !== 0 ? '&shiftCodes=' : ''}${this.shiftCodes}${this.status.length !== 0 ? '&status=' : ''}${this.status}${this.tableId ? '&tableId=' : ''}${this.tableId}${this.payOption ? '&checkType=' : ''}${this.payOption}${this.ramadhinOption ? '&mealTableNum=' : ''}${this.ramadhinOption}${this.orderNumber ? '&orderNum=' : ''}${this.orderNumber}${this.workOption ? '&userName=' : ''}${this.workOption}${this.orderAmount ? '&allPrice=' : ''}${this.orderAmount}`
        // let url = this.api.menuQueryTotal

        this.loading('加载中')

        let methods = 'get'

        this.$axios({
          url,
          methods
        }).then(res => {
          if (res.data.status == 0) {
            console.log();
            res.data.data.forEach(v => {
              this.allNum = v.orderCount
              this.allPrice = v.allPrice
            })
          }
        })
      },
      fetchLeftMenu() {
        console.log(123, this.tableId, this.currentTitle);
        if (this.currentTitle == 0) {
          this.startTime = this.timevalue1
          this.endTime = this.timevalue1
        }

        if (this.tableId) {
          console.log(123);
          this.startTime = ''
          this.endTime = ''
        }
        // let url = this.api.menuQuery + '?startTime=' + this.startTime  + '&endTime=' + this.endTime  + '&outletsIds=' + this.outletsIds + '&shiftCodes=' + this.shiftCodes + '&status=' + this.status
        let url =
          `${this.api.menuQuery}?startTime=${this.startTime ?  this.startTime : ''}&endTime=${this.endTime ? this.endTime : ''}${this.outletsIds.length !== 0 ? '&outletsIds=' : ''}${this.outletsIds}${this.shiftCodes.length !== 0 ? '&shiftCodes=' : ''}${this.shiftCodes}${this.status.length !== 0 ? '&status=' : ''}${this.status}${this.tableId ? '&tableId=' : ''}${this.tableId}${this.payOption ? '&checkType=' : ''}${this.payOption}${this.ramadhinOption ? '&mealTableNum=' : ''}${this.ramadhinOption}${this.orderNumber ? '&orderNum=' : ''}${this.orderNumber}${this.workOption ? '&userName=' : ''}${this.workOption}${this.orderAmount ? '&allPrice=' : ''}${this.orderAmount}`
        // console.log(url);
        let methods = 'get'
        let data = {
          startTime: this.timevalue1,
          endTime: this.timevalue1,
          outletsIds: this.outletsIds,
          shiftCodes: this.shiftCodes,
          status: this.status,
        }
        this.loading('加载中')

        this.$axios({
          url,
          methods
        }).then(res => {
          if (res.data.status == 0) {
            this.menuQueryTotal()
            console.log('数据', res.data.data);
            this.getlist = res.data.data
            this.leftMenuList = res.data.data
            this.queryDialog = false



          }
        })
      },

      onclicks(v) {
        if (this.leftMenuList.length) {
          this.leftMenuList.map((res, i) => {
            if (res.id == v) {
              this.queryDetails(res, i)
            }
          })

        } else {
          setTimeout(() => {
            this.onclicks(v)
          }, 500);
        }
      },
      todayOrhistory(i) {

        this.currentTitle = i

        if (this.currentTitle == 0) {
          //今天
          this.$store.commit('todayTime')
          this.startTime = this.timevalue1
          this.endTime = this.timevalue1
          this.status = ['O', 'G', 'S']
          this.statusList = ['O', 'G', 'S']
          this.tableId = ''
          this.queryName=''
          this.fetchLeftMenu()
        } else {
          //历史
          this.$store.commit('historyTime')
          this.queryDialog = true
          this.status = ['O', 'G', 'S']
          this.statusList = ['O', 'G', 'S']
          this.tableId = ''
          this.queryName=''
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          this.value1 = [start, end]

          if (this.value1[0]) {
            this.startTime = DateUtils.formatDate(new Date(start),
              "yyyy-MM-dd");
          }
          if (this.value1[1]) {
            this.endTime = DateUtils.formatDate(new Date(end),
              "yyyy-MM-dd")
          }

        }
        this.$bus.emit('orderMenu', '')
        this.$bus.emit('routeStatus', 1)
        this.$bus.emit('nowID', '')
        this.$bus.emit('nowstatus', '')
      },
      changedate(val) {
        console.log(val);
      },
      Success() {
        let orderID = JSON.parse(localStorage.getItem('queryDetails'))
        if (!this.none) {
          this.fetchLeftMenu()
        } else {
          this.startTime = ''
          this.endTime = ''
        }
        this.leftMenuList = []
        this.getlist = []
        this.$bus.emit('orderMenu', '')
        this.$bus.emit('routeStatus', 1)
        this.$bus.emit('nowID', '')
        this.$bus.emit('nowstatus', '')
      },
      handleCheckAllChange(val) {
        console.log(val);
        this.statusList = val ? ['O', 'G', 'S', 'C'] : [];
        if (this.statusList.length !== 0) {

          this.status = this.statusList
          this.none = false
          // return
          console.log(1111, this.startTime, this.endTime);
          this.fetchLeftMenu()
          this.menuQueryTotal()
        } else {

          this.statu = []
          this.allNum = 0
          this.allPrice = 0
          this.leftMenuList = []
          this.getlist = []

          this.none = true
          this.Success()
        }

        this.isIndeterminate = false;
      },
      checkListChange(v) {
        console.log(this.checkList.length);
        console.log(this.status);
        let checkedCount = v.length;
        // console.log(v);
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkList.length;
        if (v.length !== 0) {
          console.log(1);
          v.map(e => {

            if (e == 'A') {

              this.statusList = ['O', 'G', 'S', 'C', 'A']

            }

          })
          this.status = this.statusList
          this.none = false
          // return
          this.fetchLeftMenu()
          this.menuQueryTotal()
        } else {

          console.log(2);
          this.statu = []
          this.allNum = 0
          this.allPrice = 0
          this.leftMenuList = []
          this.getlist = []

          this.none = true
          this.Success()

        }


      },
      getOutletsIdList() {
        let methods = 'get'
        let url = this.api.getoutlets + '?posCode=' + localStorage.getItem('posCode')
        this.loading('加载中')

        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.cantList = [{
            description: "所有"
          }, ]
          res.data.data.forEach(v => {

            this.$set(v, 'check', false)
            this.cantList.push(v)
          });
        })
        url = this.api.getListMap2
        this.$axios({
          methods,
          url
        }).then(res => {
          this.workOptions = res.data.data
        })
        url = this.api.posProductPayList + '?posBill=Y'


        this.$axios({
          url,
          methods
        }).then(res => {
          // console.log('支付图片', res);
          this.payOptions = res.data.data
        })
        this.getramadhinOptions()
      },
      getramadhinOptions() {
        let url = ''
        let methods = 'get'
        let arr = []
        this.cantList.map(res => {
          if (res.check) {
            arr.push(res.id)
          }
        })
        // console.log(arr);
        if (arr.length) {

          url = this.api.getTableNumList + '?outletsIds=' + arr + '&posCode=' + localStorage.getItem('posCode')
        } else {
          url = this.api.getTableNumList + '?posCode=' + localStorage.getItem('posCode')
        }
        this.$axios({
          url,
          methods
        }).then(res => {
          // console.log('支付图片', res);
          this.ramadhinOptions = res.data.data
        })
      },
      checkbcCurrent(v, i) {
        if (v.check) {
          v.check = false
        } else {
          v.check = true
        }
        if (i == 0) {
          if (v.check) {
            this.ShiftList.forEach(val => {
              val.check = true
            })
          } else {
            this.ShiftList.forEach(val => {
              val.check = false
            })
          }
        } else if (i !== 0) {
          if (!v.check) {
            this.ShiftList[this.ShiftList.length - 1].check = false
          }
        }

      },
      checkyydCurrent(v, i) {
        if (v.check) {
          v.check = false
          this.$set(v, 'check', false)
        } else {
          this.$set(v, 'check', true)
          v.check = true
        }

        if (i == 0) {
          if (v.check) {
            this.cantList.forEach(val => {
              val.check = true
            })
          } else {
            this.cantList.forEach(val => {
              val.check = false
            })
          }
        } else if (i !== 0) {
          if (!v.check) {
            this.cantList[this.cantList.length - 1].check = false
          }
        }
        this.getramadhinOptions()
      },
      resetClick() {
        this.ShiftList.forEach(val => {
          val.check = false
        })
        this.cantList.forEach((val, i) => {
          val.check = false
        })

        this.value1 = ''
        this.workOption = ''
        this.ramadhinOption = ''
        this.payOption = ''
        this.orderAmount = ''
        this.orderNumber = ''

      },
      //组合查询确定按钮
      CombinedQuery() {
        this.shiftArr = []
        this.ctArr = []
        this.ctArrs = []
        this.ShiftList.forEach(val => {
          if (val.check) {
            console.log(val.val);
            if (val.val) {
              this.shiftArr.push(val.val)
            } else {
              this.shiftArr = []
            }
          }
        })
        this.cantList.forEach((val, i) => {
          if (val.check) {
            if (val.id) {
              this.ctArr.push(val.code)
              this.ctArrs.push(val.id)

            } else {
              this.ctArr = []
              this.ctArrs = []
            }
          }
        })

        if (this.value1[0]) {

          this.startTime = DateUtils.formatDate(new Date(this.value1[0]),
            "yyyy-MM-dd");
        }
        if (this.value1[1]) {
          this.endTime = DateUtils.formatDate(new Date(this.value1[1]),
            "yyyy-MM-dd")
        }

        this.outletsIds = this.ctArr
        this.shiftCodes = this.shiftArr


        this.fetchLeftMenu()
      },
      //搜索框模糊查询
      searchMain(val) {

        let arr = []
        if (val) {
          let price = 0
          this.getlist.forEach(e => {

            if ((e.allPrice + '').indexOf(val) != -1 || e.mealTableNum.indexOf(val) != -1 || e.orderNum.indexOf(
                val) != -
              1) {
              arr.push(e)
              price += e.allPrice * 1
            }
          })
          this.leftMenuList = arr
          this.allPrice = price
        } else {
          this.fetchLeftMenu()
        }
      },
      GetPrinter() {
        //获取当前打印机

        LODOP = getLodop();

        var iCount = LODOP.GET_PRINTER_COUNT();

        var PData = [];

        for (var i = 0; i < iCount; i++) {
          PData.push({
            code: i,
            name: LODOP.GET_PRINTER_NAME(i)
          });
        }

        return PData;
      },
      todoExport() {
        this.printFlag = true
        this.PDate = this.GetPrinter()

      },
      printexcel() {
        this.$bus.$emit('excel', 1)
      },
      printtable() {
        if (this.printName) {
          this.$bus.$emit('printtable', this.printName)

        } else {
          this.$message({
            message: "请先选择打印机",
            type: "warning"
          })
        }
      },
      changePDate(v) {
        // console.log('选择打印机', v);
        localStorage.setItem('printName', v)
        this.printName = v
        // this.$refs.bill.getPrint()
      },

    },
  };
</script>

<style lang="scss" scoped>
  .homeContent {
    width: 100%;
    display: grid;
    grid-template-columns: 46% 54%;

    .leftNav {
      height: calc(100vh - 84px);
      background: #fff;
      border-right: 1px solid #eee;

      .leftTitle {
        width: 100%;
        height: 66px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: 1px solid #eaeaea;
        // position: relative;
        padding: 0 10px;

        .search {
          width: 100px;
          background: #339af0;
          height: 30px;
          line-height: 30px;
          border-radius: 4px;
          color: #fff;
          text-align: center;
          margin: 0 10px;
          font-size: 14px;
        }

        /deep/ .el-input--suffix {
          margin-bottom: 0;
        }

        .searchBtn {
          cursor: pointer;
          font-size: 14px;
          margin-left: 20px;
        }

        .titleItem {
          width: 100px;
          height: 35px;
          background: #fff;
          border: 1px solid rgba(204, 204, 204, 1);
          ;
          border-radius: 25px;
          text-align: center;
          line-height: 35px;
          font-size: 20px;
          color: #666;
          margin-right: 10px;
          cursor: pointer;
        }

        .titleItemCurrent {
          background: #0099ff;
          color: #fff;
          border-radius: 25px;
        }
      }

      .leftMain {
        height: calc(100% - 207px);
        overflow: auto;

        .selectTitle {
          display: grid;
          grid-template-columns: 100px 60px 60px 80px 80px 60px 60px 40px 60px 1fr 50px;
          padding: 0 10px;
          height: 40px;
          align-items: center;
          font-size: 14px;
          border-bottom: 1px solid #eaeaea;
          background: #339af0;
          text-align: center;
          color: #fff;
          position: sticky;
          top: 0px;
        }

        .contentItem {
          display: grid;
          grid-template-columns: 100px 60px 60px 80px 80px 60px 60px 40px 60px 1fr 50px;
          padding: 0 10px;
          height: 40px;
          align-items: center;
          font-size: 14px;
          text-align: center;
          border-bottom: 1px solid #eaeaea;
          cursor: pointer;
          color: rgb(102, 102, 102);

          .leftOne {
            width: 160px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #666;
            border-right: 1px solid #eaeaea;

            div:nth-child(1) {
              margin: 16px 0;
              font-size: 24px;
            }

            div:nth-child(2) {
              font-size: 20px;
            }
          }

          .leftCenter {
            display: flex;
            justify-content: space-between;
            width: calc(100% - 242px);

            .dh {
              display: flex;
              flex-direction: column;
              margin: 0 0 0 30px;
              color: #666;

              div:nth-child(1) {
                margin: 16px 0;
                font-size: 24px;
              }

              div:nth-child(2) {
                font-size: 20px;
              }
            }

            .money {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              margin: 0 0 0 30px;
              color: #666;

              div:nth-child(1) {
                margin: 16px 0;
                font-size: 24px;
                color: #fe8d30;
              }

              div:nth-child(2) {
                font-size: 20px;
              }
            }
          }
        }

        .currentContentItem {
          background: #edf8ff;
          border: 2px solid #0099ff;
        }
      }

      .leftBottom {
        border-top: 1px solid #eaeaea;
        color: #666;

        .bottomOne {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 14px;
          height: 60px;
          font-size: 18px;
        }

        .bottomTwo {
          width: 100%;
          display: flex;
          justify-content: space-around;
          // margin-top: 10px;
          align-items: center;
          border-top: 1px solid #eee;
          height: 79px;

          /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
          .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #fe8d30;
            border-color: #fe8d30;
            border-radius: 10px;
            width: 20px;
            height: 20px;
          }

          /deep/.el-checkbox__inner {
            border-radius: 10px;
            width: 20px;
            height: 20px;
          }

          /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #fe8d30;
            border-color: #fe8d30;
            border-radius: 10px;
            width: 20px;
            height: 20px;
          }

          /deep/.el-checkbox__inner::after {
            height: 11px;
            left: 6px;
            top: 1px;
            width: 6px;
          }

          /deep/.el-checkbox__label {
            color: #666;
            font-size: 18px;
          }
        }
      }
    }

    .returnItemCurrent {
      background: #0099ff !important;
      color: #fff;
    }

    .changeReason {
      padding: 0 20px;
      display: grid;
      grid-template-columns: 200px 1fr;
      align-items: center;
      font-size: 14px;

      /deep/.el-input__inner {
        font-size: 14px;
        width: 450px !important;
      }

      /deep/ .el-input--suffix {

        width: 440px !important;
      }

      /deep/ .el-select__tags {
        max-width: 440px !important;
        width: 440px !important;
        flex-wrap: unset;
        overflow: hidden;
      }


      .returnTitle {
        margin: 20px 0 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        text-align: right;
        margin-right: 20px;
      }

      .returnItem {
        display: flex;
        flex-wrap: wrap;

        div {
          margin: 5px 20px 5px 0;
          font-size: 14px;
          width: 100px;
          height: 40px;
          background: #eeeeee;
          border-radius: 6px;
          line-height: 40px;
          text-align: center;
          cursor: pointer;
        }
      }

      .returnFoodMain {
        height: 66px;
        display: flex;
        width: 100%;
        margin-top: 16px;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
      }

      .guestMain {
        margin-top: 20px;
      }
    }

    .view {
      height: calc(100vh - 84px);
      background: #fff;
      display: flex;
      flex-direction: column;
    }
  }

  .printSelect {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .PDateName {
      border: 1px solid #666;
      width: 200px;
      height: 30px;
      margin-left: 20px;

      /deep/.el-input__inner {
        // border: none;
        width: 200px !important;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        // line-height: 0 !important;
        background: transparent;
      }

      /deep/ .el-input--suffix {
        margin-bottom: 0;
      }
    }
  }
</style>
<style lang="scss" scoped>
  /deep/.el-button--primary {
    border-radius: 38px;
    width: 160px;
    background: -webkit-gradient(linear,
        0 0,
        0 100%,
        from(#ffbe34),
        to(#fe812f)) !important;
    border: none;
  }

  /deep/.el-button {
    font-size: 18px;
    height: 60px;
    font-weight: 400;
  }

  /deep/.el-dialog__footer {
    margin-bottom: 30px;
    width: 100%;
  }

  /deep/.el-dialog {
    // height: 612px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
  }

  /deep/.el-dialog__header {
    margin-top: 50px;
    background: #fff;
  }

  /deep/.el-dialog__title {
    color: #0099ff;
    font-size: 18px;
  }

  /deep/.el-input--suffix {
    margin-bottom: 20px;
  }

  /deep/.el-dialog__body {
    // height: 412px;
    overflow: hidden;
  }

  .titleTTT {
    margin-bottom: 10px;
    color: #666;
  }

  /deep/.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }

  /deep/.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
</style>